import { Link } from "react-router";

import { buildSessionUrl } from "@/components/pages_logged_in/roleplays/utils";
import { RankIcon } from "@/components/pieces/roleplays/RankIcon";
import { Card } from "@/components/ui/card";
import { RoleplayRank } from "@/graphql";
import { formatDate } from "@/utils/datetime";

interface SessionHistoryListSectionProps {
  sessions: {
    uuid: string;
    updatedAt: string;
    rank: RoleplayRank;
    score: number;
    scenarioSlug?: string;
  }[];
  scenarioSlug?: string;
  assigneeName?: string;
}

export const SessionHistoryListSection = ({
  sessions,
  scenarioSlug,
  assigneeName,
}: SessionHistoryListSectionProps) => {
  return (
    <div className="space-y-3">
      <h3 className="font-semibold text-base text-black">History</h3>
      <div className="space-y-3">
        {sessions.length === 0 ? (
          <Card className="p-8 text-center text-gray-500">
            <span className="text-sm mt-2">
              {assigneeName || "You"} doesn't have any sessions yet
            </span>
          </Card>
        ) : (
          sessions.map((session) => {
            if (!session) return null;
            const url = buildSessionUrl({
              scenarioSlug: session?.scenarioSlug || scenarioSlug || "",
              sessionUuid: session?.uuid || "",
            });

            return (
              <Link
                key={url}
                to={url}
                className="block transition-colors duration-200 text-gray-900 hover:text-inherit"
              >
                <Card className="p-4 border border-neutral-300 bg-white hover:border-blue-700 transition-colors">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-[#242424]">
                      {formatDate(session?.updatedAt, "MMM do 'at' h:mm a")}
                    </span>
                    <div className="flex items-center gap-2">
                      <RankIcon
                        rank={session?.rank || RoleplayRank.Unranked}
                        size={24}
                      />
                      {session?.score ? (
                        <span className="text-sm text-[#242424]">
                          {Math.round(session?.score || 0)}%
                        </span>
                      ) : (
                        <span className="text-sm text-[#242424]">Unranked</span>
                      )}
                    </div>
                  </div>
                </Card>
              </Link>
            );
          })
        )}
      </div>
    </div>
  );
};
